export const getPatientUrl = ({ patientId }: { patientId: string }) =>
  `patients/${patientId}`;
